import { Component, OnInit } from '@angular/core';

import * as moment from 'moment';
import { FacturationService } from 'src/app/services/facturation.service';
import { DateCalculationService } from 'src/app/services/date-calculation.service';
import { SelectItem } from 'primeng/api';

import * as Excel from 'exceljs';
import * as FileSaver from 'file-saver';
import { ContenusModule } from '../moderation/contenus/contenus.module';
import { EncryptionService } from 'src/app/services/encryption.service';
import { AnyARecord } from 'dns';
import { timeout } from 'rxjs/operators';


/**
 * 
 * 
 * ## [06/12/2021]
 * ### SOURCE [Mail]
 * - Objet : 005897 ANCV : demande ajout "mois" dans l'onglet facturation
 * - Demandeur : Tsiry
 * - Date :  06/12/2021 10:34
 * 
 * ### MODIFICATIONS
 * - Ajout variable pour obtenir le mois et l'année
 * --- Fonctions impactées :[ngOnInit, getFacturationGeneral]
 * 
 */



@Component({
  selector: 'app-facturation',
  templateUrl: './facturation.component.html',
  styleUrls: ['./facturation.component.css']
})
export class FacturationComponent implements OnInit {

  VolumetrieFiltre: any[] = [
    {label : 'Nombre total de fiches validées / degré de complexité', value : 0},
    {label : 'Nombre total de fiches en attente validation / degré de complexité', value : 1},
  ];

  complexteFilter: SelectItem[] = [
    {label : 'FORTE', value : 3 },
    {label : 'MOYENNE', value : 2 },
    {label : 'FAIBLE', value : 1 }
  ];

  selectedOptionVolumetrie = 0;
  valueDate: Date;
  valueSemaine: Date;
  valuMois: Date;
  valuePeriode: Date;

  fr: any;
  activeIndexTabView = 0;


  nbValides : number = 0;
  nbAttentes : number = 0;


  lastFaible : number = 0;
  lastMoyenne : number = 0;
  lastForte : number = 0;
  lastValidesFaible : number = 0;
  lastValidesMoyenne : number = 0;
  lastValidesForte : number = 0;
  lastAttenteFaible : number = 0;
  lastAttenteMoyenne : number = 0;
  lastAttenteForte : number = 0;
  lastFactureeFaible : number = 0;
  lastFactureeMoyenne : number = 0;
  lastFactureeForte : number = 0;

  currentFaible : number = 0;
  currentMoyenne : number = 0;
  currentForte : number = 0;
  currentValidesFaible : number = 0;
  currentValidesMoyenne : number = 0;
  currentValidesForte : number = 0;
  currentAttenteFaible : number = 0;
  currentAttenteMoyenne : number = 0;
  currentAttenteForte : number = 0;
  currentFactureeFaible : number = 0;
  currentFactureeMoyenne : number = 0;
  currentFactureeForte : number = 0;


  allFaible : number = 0;
  allMoyenne : number = 0;
  allForte : number = 0;
  allValidesFaible : number = 0;
  allValidesMoyenne : number = 0;
  allValidesForte : number = 0;
  allAttenteFaible : number = 0;
  allAttenteMoyenne : number = 0;
  allAttenteForte : number = 0;
  allFactureeFaible : number = 0;
  allFactureeMoyenne : number = 0;
  allFactureeForte : number = 0;

  validesParComplexite : any;
  attentesParComplexite : any;
  nbTraiteesOptions : any = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true
          }
        }
      ],
      xAxes: [
        {
          ticks: {
            beginAtZero: true
          }
        }
      ]
    },
    plugins : {
      datalabels: {
        color : '#000000',
        font: {
          weight:'bold',
          size: 16
        }
      }
    }
  }

  volumetrieCols : any[] = [
    {field: 'complexite', header : 'Complexité'},
    {field: 'facturable', header : 'Facturables'},
    {field: 'facturee', header : 'Facturées'},
    {field: 'attentes', header : 'En attente'},
   // {field: 'total', header : 'TOTAL'},
  ];
  lastMonthValues : any[] = [];
  currentMonthValues : any[] = [];
  allMonthValues : any[] = [];

  tableauCols : any[] = [
    {field: 'id_complexite', header: 'Complexité'},
    {field: 'date_action', header: 'Date'},
    {field: 'num_point_accueil', header: 'ID PTL'},
  ];
  listeValidees : any[];
  listeAttente : any[];

  mois:string = '';
  lastMois:string = '';

  btnFacturationDisable:boolean = false;



  listeAttenteCols : any[] = [
    {field: 'login', header : 'Login PTL'},
    {field: 'date_action', header : 'Date de livraison'},
    {field: 'duree_attente', header : 'Durée d\'attente'}
  ];

  listeAttenteImportant : any[] = [];


  user : Object = {};

  constructor(private facturationService : FacturationService, private dateService: DateCalculationService, private encryptService:EncryptionService) { }

  ngOnInit(): void {
    this.user = JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));
    this.fr = this.dateService.getFrLocale();
    let now = new Date();
    let startMonth = moment(now).startOf('month').format('YYYY-MM-DD');
    let endMonth = moment(now).endOf('month').format('YYYY-MM-DD');
    let nonFormatedMonth = moment(startMonth).format('MM-YYYY');
    this.mois = this.dateService.getCurrentMois(nonFormatedMonth);

    let startDate = new Date(startMonth);
    let lastEndMonth = moment(startDate).subtract(1,'days').format('YYYY-MM-DD');
    let endDate = new Date(lastEndMonth);
    let lastStartMonth = moment(endDate).startOf('month').format('YYYY-MM-DD');
    let monthFormatedLastMonth = moment(lastStartMonth).format('MM-YYYY');
    this.lastMois = this.dateService.getCurrentMois(monthFormatedLastMonth);

    this.getData(startMonth, endMonth, lastStartMonth, lastEndMonth);

  }

  // Fonction pour Multi Range Date
  selectRangeWeek(evt) {
    const start = new Date(evt);
    start.setDate(start.getDate() - start.getDay());
    this.valueSemaine[0] = start;
    const end = new Date(start);
    end.setDate(start.getDate() + 6);
    this.valueSemaine[1] = end;
  }

  /**
   * Recuperation de la facturation entre deux dates
   */
  getFacturationGeneral(startMonth: string, endMonth: string, lastStartMonth:string, lastEndMonth:string) {
    this.facturationService.getNbFiches(startMonth, endMonth).subscribe(value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + value["cause"]);
      }else {
        let nb = value['data'];
        this.nbValides = parseInt(nb['valide_faible']) + parseInt(nb['valide_moyenne']) + parseInt(nb['valide_forte']);
        this.nbAttentes = parseInt(nb['attente_faible']) + parseInt(nb['attente_moyenne']) + parseInt(nb['attente_forte']);

        this.currentFaible = parseInt(nb['valide_faible']) + parseInt(nb['attente_faible']) + parseInt(nb['facturee_faible']);
        this.currentMoyenne = parseInt(nb['valide_moyenne']) + parseInt(nb['attente_moyenne']) + parseInt(nb['facturee_moyenne']);
        this.currentForte = parseInt(nb['valide_forte']) + + parseInt(nb['attente_forte']) + parseInt(nb['facturee_forte']);
        this.currentValidesFaible = parseInt(nb['valide_faible']);
        this.currentValidesMoyenne =  parseInt(nb['valide_moyenne']);
        this.currentValidesForte = parseInt(nb['valide_forte']);
        this.currentAttenteFaible = parseInt(nb['attente_faible']);
        this.currentAttenteMoyenne = parseInt(nb['attente_moyenne']);
        this.currentAttenteForte = parseInt(nb['attente_forte']);
        this.currentFactureeFaible = parseInt(nb['facturee_faible']);
        this.currentFactureeMoyenne = parseInt(nb['facturee_moyenne']);
        this.currentFactureeForte = parseInt(nb['facturee_forte']);

        this.currentMonthValues = [
          {
            complexite : 'Faible',
            //valides : this.currentValidesFaible,
            attentes : this.currentAttenteFaible,
            total : this.currentFaible,
            facturable : this.currentValidesFaible,
            facturee : this.currentFactureeFaible
          },
          {
            complexite : 'Moyenne',
            //valides : this.currentValidesMoyenne,
            attentes : this.currentAttenteMoyenne,
            total : this.currentMoyenne,
            facturable : this.currentValidesMoyenne,
            facturee : this.currentFactureeMoyenne
          },
          {
            complexite : 'Forte',
            //valides : this.currentValidesForte,
            attentes : this.currentAttenteForte,
            total : this.currentForte,
            facturable : this.currentValidesForte,
            facturee : this.currentFactureeForte
          },
        ];


        this.validesParComplexite = {
          labels: [''],
          datasets : [
            {
              label: 'Faible',
              backgroundColor: '#6495ED',
              borderColor: '#1E88E5',
              data: [nb['valide_faible']]
            },
            {
              label: 'Moyenne',
              backgroundColor: '#FF8C00',
              borderColor: '#1E88E5',
              data: [nb['valide_moyenne']]
            },
            {
              label: 'Forte',
              backgroundColor: '#A9A9A9',
              borderColor: '#1E88E5',
              data: [nb['valide_forte']]
            },
          ]

        };

        this.attentesParComplexite = {
          labels: [''],
          datasets : [
            {
              label: 'Faible',
              backgroundColor: '#6495ED',
              borderColor: '#1E88E5',
              data: [nb['attente_faible']]
            },
            {
              label: 'Moyenne',
              backgroundColor: '#FF8C00',
              borderColor: '#1E88E5',
              data: [nb['attente_moyenne']]
            },
            {
              label: 'Forte',
              backgroundColor: '#A9A9A9',
              borderColor: '#1E88E5',
              data: [nb['attente_forte']]
            },
          ]
        };
      }
    });

    this.facturationService.getNbFiches(lastStartMonth, lastEndMonth).subscribe(value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + value["cause"]);
      }else {
        let nb = value['data'];
        this.lastFaible = parseInt(nb['valide_faible']) + parseInt(nb['attente_faible']) + parseInt(nb['facturee_faible']);
        this.lastMoyenne = parseInt(nb['valide_moyenne']) + parseInt(nb['attente_moyenne']) + parseInt(nb['facturee_moyenne']);
        this.lastForte = parseInt(nb['valide_forte']) + + parseInt(nb['attente_forte']) + parseInt(nb['facturee_forte']);
        this.lastValidesFaible = parseInt(nb['valide_faible']);
        this.lastValidesMoyenne =  parseInt(nb['valide_moyenne']);
        this.lastValidesForte = parseInt(nb['valide_forte']);
        this.lastAttenteFaible = parseInt(nb['attente_faible']);
        this.lastAttenteMoyenne = parseInt(nb['attente_moyenne']);
        this.lastAttenteForte = parseInt(nb['attente_forte']);
        this.lastFactureeFaible = parseInt(nb['facturee_faible']);
        this.lastFactureeMoyenne = parseInt(nb['facturee_moyenne']);
        this.lastFactureeForte = parseInt(nb['facturee_forte']);

        this.lastMonthValues = [
          {
            complexite : 'Faible',
            //valides : this.lastValidesFaible,
            attentes : this.lastAttenteFaible,
            total : this.lastFaible,
            facturable : this.lastValidesFaible,
            facturee : this.lastFactureeFaible
          },
          {
            complexite : 'Moyenne',
            //valides : this.lastValidesMoyenne,
            attentes : this.lastAttenteMoyenne,
            total : this.lastMoyenne,
            facturable : this.lastValidesMoyenne,
            facturee : this.lastFactureeMoyenne
          },
          {
            complexite : 'Forte',
            //valides : this.lastValidesForte,
            attentes : this.lastAttenteForte,
            total : this.lastForte,
            facturable : this.lastValidesForte,
            facturee : this.lastFactureeForte
          },
        ];
      }
    });
  }

/**
 * Récupération de la facturation en general 
 */
  getFacturationAllGeneral() {
    this.facturationService.getNbFichesAll().subscribe(value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + value["cause"]);
      }else {
        let nb = value['data'];

        this.allFaible = parseInt(nb['valide_faible']) + parseInt(nb['attente_faible']) + parseInt(nb['facturee_faible']);
        this.allMoyenne = parseInt(nb['valide_moyenne']) + parseInt(nb['attente_moyenne']) + parseInt(nb['facturee_moyenne']);
        this.allForte = parseInt(nb['valide_forte']) + + parseInt(nb['attente_forte']) + parseInt(nb['facturee_forte']);
        this.allValidesFaible = parseInt(nb['valide_faible']);
        this.allValidesMoyenne =  parseInt(nb['valide_moyenne']);
        this.allValidesForte = parseInt(nb['valide_forte']);
        this.allAttenteFaible = parseInt(nb['attente_faible']);
        this.allAttenteMoyenne = parseInt(nb['attente_moyenne']);
        this.allAttenteForte = parseInt(nb['attente_forte']);
        this.allFactureeFaible = parseInt(nb['facturee_faible']);
        this.allFactureeMoyenne = parseInt(nb['facturee_moyenne']);
        this.allFactureeForte = parseInt(nb['facturee_forte']);

        this.allMonthValues = [
          {
            complexite : 'Faible',
            //valides : this.currentValidesFaible,
            attentes : this.allAttenteFaible,
            total : this.allFaible,
            facturable : this.allValidesFaible,
            facturee : this.allFactureeFaible
          },
          {
            complexite : 'Moyenne',
            //valides : this.currentValidesMoyenne,
            attentes : this.allAttenteMoyenne,
            total : this.allMoyenne,
            facturable : this.allValidesMoyenne,
            facturee : this.allFactureeMoyenne
          },
          {
            complexite : 'Forte',
            //valides : this.currentValidesForte,
            attentes : this.allAttenteForte,
            total : this.allForte,
            facturable : this.allValidesForte,
            facturee : this.allFactureeForte
          },
        ];
      }
    });
  }

  /***
   * Recuperation des listes des fiches en attente et fiches validées
   */
  getDetails(startMonth:string, endMonth:string){
    this.facturationService.getListeAttente(startMonth, endMonth).subscribe(value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + value["cause"]);
      }else {
        this.listeAttente = value['data'];
      }
    });

    this.facturationService.getListeValidees(startMonth, endMonth).subscribe(value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + value["cause"]);
      }else {
        this.listeValidees = value['data'];
      }
    });

  }


  /***
   * récuperation de la liste des fiches en attente depuis plus de 10 jours
   */
  getListeFichesAttenteImportant() {
    this.facturationService.getFichesAttenteImportant().subscribe( value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + value["cause"]);
      }else {
        let liste = value['data'];
        this.listeAttenteImportant = [];
        liste.forEach(current => {
          
          let day = (current.duree_attente.days) ? current.duree_attente.days + 'j' : '';
          let hour = (current.duree_attente.hours) ? current.duree_attente.hours + 'h' : '';

          let sortie = {
            login : current.num_point_accueil,
            date_action : current.date_action,
            duree_attente : day + ' ' + hour 
          };

          this.listeAttenteImportant.push(sortie);
        });
      }
    });
  }


  /***
   * Récupérationd de toutes les données
   */
  getData(startMonth:string,endMonth:string, lastStartMonth:string, lastEndMonth){
    this.getFacturationGeneral(startMonth,endMonth,lastStartMonth,lastEndMonth);
    this.getFacturationAllGeneral();
    this.getListeFichesAttenteImportant();
   // this.getDetails(startMonth,endMonth);
  }

   // Filtre Reporting
   loadFiltreReporting() {
    // alert(this.activeIndexTabView);
    const filtre_date = this.getDateFromCurrentTabView();
    if (filtre_date == null)
    {
      alert('Veuillez selecitonner une date');
      return;
    }
    // Chargement Filtre Date

    let startDate = new Date(filtre_date.date_deb);
    let lastEndMonth = moment(startDate).subtract(1,'days').format('YYYY-MM-DD');
    let endDate = new Date(lastEndMonth);
    let lastStartMonth = moment(endDate).startOf('month').format('YYYY-MM-DD');
    let nonFormatedMonth = moment(startDate).format('MM-YYYY');
    this.mois = this.dateService.getCurrentMois(nonFormatedMonth);
    let monthFormatedLastMonth = moment(lastStartMonth).format('MM-YYYY');
    this.lastMois = this.dateService.getCurrentMois(monthFormatedLastMonth);

    this.getData(filtre_date.date_deb, filtre_date.date_fin, lastStartMonth, lastEndMonth);
  }

  // Recuperation Valeur Date Filtre
  getDateFromCurrentTabView() {
    switch (this.activeIndexTabView) {

      // CALENDAR MOIS
      case(0) : {
        const date_string_Deb  = moment(this.valuMois).startOf('month').format('YYYY-MM-DD');
        const date_string_Fin  = moment(this.valuMois).endOf('month').format('YYYY-MM-DD');
        const objectDate = {
          date_deb: date_string_Deb,
          date_fin: date_string_Fin, // '2020-09-10'
        };
        // alert(JSON.stringify(objectDate));
        return objectDate;
        break;
      }

    }
  }

  /**
   * Récupération de la complexite à partir de son id
   * @param idComplexite 
   * @returns 
   */
  getComplexite(idComplexite: number) {
    switch (idComplexite) {
      case(1) : {
        return 'FAIBLE';
        break;
      }
      case(2) : {
        return 'MOYENNE';
        break;
      }
      case(3) : {
        return 'FORTE';
        break;
      }
    }
  }


  /**
   * Confirmation du lancement de la facturation
   */
  promptFacture() {
    let goFacturer = confirm("Êtes-vous certain de facturer pour le mois " + this.mois + "?");

    if(goFacturer) {
      this.facturer();
    }
  }

  /**
   * Lancement de la facturation
   * @returns 
   */
  facturer() {
    
    const filtre_date = this.getDateFromCurrentTabView();
    if (filtre_date == null)
    {
      alert('Veuillez selectionner une date');
      this.btnFacturationDisable = false;
      return;
    }


    this.getFacturables(filtre_date.date_deb, filtre_date.date_fin)

    .then((liste:any[]) => {
      if(liste.length < 1) {
        alert("Aucune fiche à facturer pour ce mois");
        return Promise.resolve([]);
      } else {
        return this.facturerFichesFacturables(liste);
      }
    })

    .then((listeComplet:any[]) => {
      console.log("liste complet");
      console.log(listeComplet);
      let valeurs = {
        faible : 0,
        moyenne : 0,
        forte : 0
      };

      valeurs.faible = this.countComplexite(listeComplet, "FAIBLE");
      valeurs.moyenne = this.countComplexite(listeComplet, "MOYENNE");
      valeurs.forte = this.countComplexite(listeComplet, "FORTE");

      this.exportNewFacture(valeurs, listeComplet);

    })

    .catch((err) => {
      console.log(err);
      alert("Une erreur s'est produite");
    });
  }


  /**
   * Compte le nombre pour une complexite bien precise
   * @param liste 
   * @param complexite 
   * @returns 
   */
  countComplexite(liste:any[],complexite:string) {
    let nombre = 0;
    
    liste.forEach((current) => {
      if(current.complexite === complexite) nombre++;
    });

    return nombre;

  }

  /**
   * Récuperation des fiches facturables
   * @param dateDebut 
   * @param dateFin 
   * @returns 
   */
  getFacturables(dateDebut:string, dateFin:string) {

    return new Promise((resolve, reject) => {

      this.facturationService.getFichesFacturables(dateDebut, dateFin)
      .subscribe(value => {
        if(value["status"] !== "success"){
          let err = "Une erreur dans la requête:" + value["cause"];
          return reject(err);
        }else {
          let datas = value['data'];
          return resolve(datas['liste_fiches']);
          //  this.exportNewFacture(datas);
        }
      })

    });

  }


  /**
   * Facturation des fiches facturables
   * @param liste 
   * @returns 
   */
  facturerFichesFacturables(liste:any[]) {
    
    return new Promise((resolve, reject) => {
      this.facturationService.facturerFiches(liste, this.user['matricule'])

      .pipe(timeout(600000))

      .subscribe(value => {

        if(value["status"] !== "success"){
          let err = "Une erreur dans la requête:" + value["cause"];
          return reject(err);
        } else {
          return resolve(value['data']);
        }

      });

    });

  }


  /**
   * Export excel de la facturation
   * @param valeurs 
   * @param debut 
   * @param fin 
   */
  async exportFacture(valeurs : any, debut:string,fin:string) {
    const workbook = new Excel.Workbook();
    const sheet = workbook.addWorksheet("facture");

    sheet.getColumn('B').width = 56;
    sheet.getColumn('A').width = 23;
    sheet.getColumn('C').width = 23;
    sheet.getCell('B2').value = 'FACTURE';
    [
      'B1',
      'B2',
      'B3',
      'B4'
    ].map(currentCell => {
      sheet.getCell(currentCell).fill = {
        type: 'pattern',
        pattern:'solid',
        fgColor:{argb:'00FAC090'}
       };

       sheet.getCell(currentCell).alignment = {
         vertical : 'middle',
         horizontal : 'center',
         wrapText : true
       };

       sheet.getCell(currentCell).font = {
        name: 'Arial Black',
        size: 16,
        bold: true
       };
    });

    sheet.getCell('B5').value = 'Du ' + moment(new Date(debut)).format('DD/MM/YYYY') + ' au ' + moment(new Date(fin)).format('DD/MM/YYYY');
    sheet.getCell('B5').alignment = {
      vertical : 'middle',
      horizontal : 'center',
      wrapText : true
    };

    let now = new Date();
    sheet.getCell('A13').value = 'Référence : Fac-' + moment(new Date(debut)).format('YYYY') + '' + moment(new Date(debut)).format('MM');
    sheet.getCell('A14').value = "Date : " + moment(now).format('DD/MM/YYYY');
    sheet.getCell('A15').value = 'N° projet : '; //+ moment(new Date(debut)).format('YYYY') + '-' + moment(new Date(debut)).format('MM');

    [
      'A13',
      'A14',
      'A15'
    ].map(currentCell => {
      sheet.getCell(currentCell).fill = {
        type: 'pattern',
        pattern:'solid',
        fgColor:{argb:'00FAC090'}
       };

       sheet.getCell(currentCell).alignment = {
         vertical : 'top',
         horizontal : 'left',
         wrapText : false
       };
    });

    sheet.mergeCells('A24:C24');

    sheet.getCell('A24').value = 'MODERATION DE CONTENUS  ET REDACTION DE FICHES SYNTHETIQUES';
    sheet.getCell('A24').font = {
      name: 'Calibri',
      size: 11,
      bold: true
     };
     sheet.getCell('A24').alignment = {
      vertical : 'top',
      horizontal : 'center',
      wrapText : false
    };


    sheet.getCell('A29').value = 'Qantité';
    sheet.getCell('A30').value = valeurs.forte;
    sheet.getCell('A31').value = valeurs.moyenne;
    sheet.getCell('A32').value = valeurs.faible;

    sheet.mergeCells('B29:C29');
    sheet.getCell('B29').value = 'Désignation';

    sheet.mergeCells('B30:C30');
    sheet.getCell('B30').value = 'Complexité forte';

    sheet.mergeCells('B31:C31');
    sheet.getCell('B31').value = 'Complexité moyenne';

    sheet.mergeCells('B32:C32');
    sheet.getCell('B32').value = 'Complexité faible';


    [
      'A29',
      'B29'
    ].map(currentCell => {
      sheet.getCell(currentCell).fill = {
        type: 'pattern',
        pattern:'solid',
        fgColor:{argb:'00F2F2F2'}
       };

       sheet.getCell(currentCell).alignment = {
         vertical : 'middle',
         horizontal : 'center',
         wrapText : false
       };
       sheet.getCell(currentCell).font = {
        name: 'Calibri',
        size: 10,
        bold: true,
        color: {argb:'00F9916d'}
       };
    });

    sheet.getCell('A29').border = {
      top: {style:'medium', color: {argb:'FF000000'}},
      left: {style:'medium', color: {argb:'FF000000'}},
      bottom: {style:'thin', color: {argb:'00808080'}},
      right: {style:'thin', color: {argb:'00808080'}}
    };

    sheet.getCell('B29').border = {
      top: {style:'medium', color: {argb:'FF000000'}},
      right: {style:'medium', color: {argb:'FF000000'}},
      bottom: {style:'thin', color: {argb:'00808080'}},
      left: {style:'thin', color: {argb:'00808080'}}
    };

    [
      'A30',
      'A31',
      'A32',
      'B30',
      'B31',
      'B32'
    ].map(currentCell => {
       sheet.getCell(currentCell).alignment = {
         vertical : 'middle',
         horizontal : 'center',
         wrapText : false
       };
       sheet.getCell(currentCell).font = {
        name: 'Calibri',
        size: 9,
        bold: false
       };
    });

    sheet.getCell('B30').border = {
      top: {style:'thin', color: {argb:'00808080'}},
      right: {style:'medium', color: {argb:'FF000000'}},
      bottom: {style:'thin', color: {argb:'00808080'}},
      left: {style:'thin', color: {argb:'00808080'}}
    };
    sheet.getCell('B31').border = {
      top: {style:'thin', color: {argb:'00808080'}},
      right: {style:'medium', color: {argb:'FF000000'}},
      bottom: {style:'thin', color: {argb:'00808080'}},
      left: {style:'thin', color: {argb:'00808080'}}
    };
    sheet.getCell('B32').border = {
      top: {style:'thin', color: {argb:'00808080'}},
      right: {style:'medium', color: {argb:'FF000000'}},
      bottom: {style:'medium', color: {argb:'FF000000'}},
      left: {style:'thin', color: {argb:'00808080'}}
    };

    sheet.getCell('A30').border = {
      top: {style:'thin', color: {argb:'00808080'}},
      left: {style:'medium', color: {argb:'FF000000'}},
      bottom: {style:'thin', color: {argb:'00808080'}},
      right: {style:'thin', color: {argb:'00808080'}}
    };
    sheet.getCell('A31').border = {
      top: {style:'thin', color: {argb:'00808080'}},
      left: {style:'medium', color: {argb:'FF000000'}},
      bottom: {style:'thin', color: {argb:'00808080'}},
      right: {style:'thin', color: {argb:'00808080'}}
    };
    sheet.getCell('A32').border = {
      top: {style:'thin', color: {argb:'00808080'}},
      left: {style:'medium', color: {argb:'FF000000'}},
      bottom: {style:'medium', color: {argb:'FF000000'}},
      right: {style:'thin', color: {argb:'00808080'}}
    };


    let name = 'Facturation-' +moment(now).format('YYYY-MM-DD');
    await workbook.xlsx.writeBuffer({useStyles:true}).then( (buffer) => {
      FileSaver.saveAs(new Blob([buffer], {type: 'application/octet-stream'}), name + '.xlsx');

      this.facturationService.facturerFiches(valeurs.liste_fiches, this.user['matricule'])
      .subscribe(value => {

        if(value["status"] !== "success"){
          console.log("Une erreur dans la requête:" + value["cause"]);
        } else {
          this.loadFiltreReporting();
        }

      });

    })
    .catch(err => {
      console.log(err);
      alert("erreur lors de la génération du fichier excel");
    });
  }


  /**
   * Nouvelle version de la facture
   * @param valeurs 
   * @param listeDetails 
   */
  async exportNewFacture(valeurs : any, listeDetails:any[]) {
    const workbook = new Excel.Workbook();
    const recapSheet = workbook.addWorksheet("RECAP");
    const detailSheet = workbook.addWorksheet("Détails");

    this.designRecapSheet(recapSheet);
    this.designDetailSheet(detailSheet);

    this.setValeursRecap(recapSheet, valeurs);
    this.setValeursDetails(detailSheet, listeDetails);

    let now = new Date();
    let name = 'Facturation-' +moment(now).format('YYYY-MM-DD');

    await workbook.xlsx.writeBuffer({useStyles:true})
    
    .then( (buffer) => {
      FileSaver.saveAs(new Blob([buffer], {type: 'application/octet-stream'}), name + '.xlsx');
      this.loadFiltreReporting();
    })
    
    .catch(err => {
      console.log(err);
      alert("erreur lors de la génération du fichier excel");
    });

  }


  /**
   * Mise en page du sheet recap
   * @param recapSheet 
   */
  designRecapSheet(recapSheet:Excel.Worksheet) {

    recapSheet.getColumn('A').width = 30;
    recapSheet.getColumn('B').width = 48;

    recapSheet.getCell('A1').value = 'Dossier';
    recapSheet.getCell('A2').value = 'Client';
    recapSheet.getCell('A3').value = 'Prestation';
    recapSheet.getCell('A4').value = 'Etat du dossier';
    recapSheet.getCell('A5').value = 'Mode facturation';

    ['A1','A2','A3','A4','A5'].map(
      (currentCell) => {
        recapSheet.getCell(currentCell).border = {
          bottom: {style:'thin', color: {argb:'00808080'}},
        };

        recapSheet.getCell(currentCell).font = {
          name: 'Calibri',
          size: 12,
          bold: true
        };
      }
    );



    recapSheet.getCell('B1').value = '005897_ANCV';
    recapSheet.getCell('B2').value = 'ANCV';
    recapSheet.getCell('B3').value = 'Modération de contenu web';
    recapSheet.getCell('B4').value = 'En cours';
    recapSheet.getCell('B5').value = 'Mensuelle';


    ['B1','B2','B3','B4','B5'].map(
      (currentCell) => {
        
        recapSheet.getCell(currentCell).font = {
          name: 'Calibri',
          size: 12,
          bold: true,
          color: { argb: '00B0F0' },
        };
      }
    );




    recapSheet.getCell('B8').value = 'Nombre de fiches';
    recapSheet.getCell('A9').value = 'Complexité faible';
    recapSheet.getCell('A10').value = 'Complexité moyenne';
    recapSheet.getCell('A11').value = 'Complexité forte';
    recapSheet.getCell('A12').value = 'TOTAL';


    ['A9','A10','A11'].map(
      (currentCell) => {
        
        recapSheet.getCell(currentCell).font = {
          name: 'Calibri',
          size: 11,
          bold: true,
        };

        recapSheet.getCell(currentCell).border = {
          top: {style:'thin', color: {argb:'FF000000'}},
          left: {style:'thin', color: {argb:'FF000000'}},
          bottom: {style:'thin', color: {argb:'00808080'}},
          right: {style:'thin', color: {argb:'00808080'}}
        };
      }
    );

    ['B8', 'B9','B10','B11', 'A12'].map(
      (currentCell) => {
        
        recapSheet.getCell(currentCell).font = {
          name: 'Calibri',
          size: 11,
          bold: true,
        };

        recapSheet.getCell(currentCell).fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'dce6f1'}
         };

        recapSheet.getCell(currentCell).border = {
          top: {style:'thin', color: {argb:'FF000000'}},
          left: {style:'thin', color: {argb:'FF000000'}},
          bottom: {style:'thin', color: {argb:'00808080'}},
          right: {style:'thin', color: {argb:'00808080'}}
        };
      }
    );


    recapSheet.getCell('B12').font = {
      name: 'Calibri',
      size: 11,
      bold: true,
    };

    recapSheet.getCell('B12').fill = {
      type: 'pattern',
      pattern:'solid',
      fgColor:{argb:'FFFF00'}
     };

    recapSheet.getCell('B12').border = {
      top: {style:'thin', color: {argb:'FF000000'}},
      left: {style:'thin', color: {argb:'FF000000'}},
      bottom: {style:'thin', color: {argb:'00808080'}},
      right: {style:'thin', color: {argb:'00808080'}}
    };
    

  } 

  /**
   * Mise en page du sheet detail
   * @param detailsSheet 
   */
  designDetailSheet(detailsSheet:Excel.Worksheet) {

    detailsSheet.getCell("A1").value = "Numéro PTL";
    detailsSheet.getCell("B1").value = "Complexité";
    detailsSheet.getCell("C1").value = "Date de Maturation";
    detailsSheet.getCell("D1").value = "Remarque";

    detailsSheet.getColumn("A").width = 17;
    detailsSheet.getColumn("B").width = 17;
    detailsSheet.getColumn("C").width = 20;
    detailsSheet.getColumn("D").width = 14;

    ["A1", "B1", "C1", "D1"].map(
      (currentCell) => {

        detailsSheet.getCell(currentCell).fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'F2F2F2'}
        };

        detailsSheet.getCell(currentCell).font = {
          name: 'Calibri',
          size: 11,
          bold: true,
        };

        detailsSheet.getCell(currentCell).border = {
          bottom: {style:'thin', color: {argb:'00D4D4D4'}},
          top: {style:'thin', color: {argb:'00D4D4D4'}},
          left: {style:'thin', color: {argb:'00D4D4D4'}},
          right: {style:'thin', color: {argb:'00D4D4D4'}},
        };

      }
    );
  }

  /**
   * Insertion des valeurs dans la recap
   * @param recapSheet 
   * @param valeurs 
   */
  setValeursRecap(recapSheet:Excel.Worksheet, valeurs:any) {
    recapSheet.getCell('B9').value = valeurs.faible;
    recapSheet.getCell('B10').value = valeurs.moyenne;
    recapSheet.getCell('B11').value = valeurs.forte;
    recapSheet.getCell('B12').value = parseInt(valeurs.faible) + parseInt(valeurs.moyenne) + parseInt(valeurs.forte);
  }

  /**
   * Insertion de la liste dans details
   * @param detailsSheet 
   * @param liste 
   */
  setValeursDetails(detailsSheet:Excel.Worksheet, liste:any[]) {

    liste.forEach((currentLine, index) => {
      let currentRow = index+2;
      detailsSheet.getCell(`A${currentRow}`).value = currentLine.num_point_accueil;
      detailsSheet.getCell(`B${currentRow}`).value = currentLine.complexite;
      detailsSheet.getCell(`C${currentRow}`).value = currentLine.date_validation;
      detailsSheet.getCell(`D${currentRow}`).value = currentLine.mis_en_simple;
    });

  }

  isClient() {
    return (parseInt(this.user['droit']) === 3) ? true : false;
  }
}
